import React from 'react';

interface SkeletonProps {
  lines?: number;
}

export const Skeleton = ({ lines = 3 }: SkeletonProps) => {
  return (
    <div className="animate-pulse space-y-3">
      {Array.from({ length: lines }).map((_, i) => (
        <div key={i} className="h-4 bg-gray-200 rounded" />
      ))}
    </div>
  );
};




